export class ScenarioSummaryModalData {
  constructor(
    public version: number,
    public availableDrugScenarioStatuses: string[]
  ) {}
}
